import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Button, message, Modal } from 'antd'
import InventoryActUpload from './InventoryActUpload'
import { updateInventoryAction, fetchInventoryByIdAction } from '../../../store/inventory'

const messageKey = 'attach_inventory_act'

const API_URL = process.env.REACT_APP_API_URL

const InventoryActAttachmentModal = ({ inventory, showModal, onCancel = () => {}, onFinish = () => {} }) => {
  const dispatch = useDispatch()

  let [attachment, setAttachment] = useState()

  useEffect(() => {
    const fetchInventory = async (id) => await dispatch(fetchInventoryByIdAction(id)).unwrap()

    if (inventory)
      fetchInventory(inventory).then(({ data }) => {
        if (data.attributes.attachment?.data) {
          const { id, attributes } = data.attributes.attachment?.data
          setAttachment({
            ...attributes,
            fileId: id,
            url: `${API_URL}${attributes.url}`,
          })
        }
      })
  }, [inventory])

  const onAddClick = useCallback(async () => {
    try {
      await dispatch(updateInventoryAction({ id: inventory, attachment: { id: attachment?.fileId } })).unwrap()
      attachment &&
        message.success({
          key: messageKey,
          content: `АПП '${attachment.name}' добавлен успешно`,
        })
      clear()
      onFinish()
    } catch (err) {
      message.error({
        key: messageKey,
        content: `Ошибка (${err.error.name}, статус: ${err.error.status}): '${err.error.errorMessage}' `,
      })
    }
  }, [inventory, attachment])

  const onCancelClick = () => {
    clear()
    onCancel()
  }

  const changeAttachmentHandler = (docs) => setAttachment(docs[0])

  const clear = () => setAttachment(null)

  return (
    <Modal
      title="Приложить АПП"
      visible={showModal}
      onCancel={onCancelClick}
      footer={[
        <Button key="back" onClick={onCancelClick}>
          Отмена
        </Button>,
        <Button key="save" type="primary" onClick={onAddClick}>
          Добавить
        </Button>,
      ]}
    >
      <InventoryActUpload docs={attachment ? [attachment] : []} onDocListChange={changeAttachmentHandler} />
    </Modal>
  )
}

export default InventoryActAttachmentModal
